// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SidebarContainer.css
.sidebar {
  background-color: #343a40;
  color: #c2c7d0;
 
  padding-top: 20px;
}

.brand-link {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  text-align: center;
  margin-bottom: 1rem;
}

.brand-link img {
  height: 50px;
  width: 50px;
  margin-right: 10px;
  border-radius: 50%;
}

.brand-text {
  font-weight: lighter;
  color: gray;
}

.menu {
  padding-left: 0;
}

.menu .menu-item {
  padding: 10px 20px;
}

.menu .menu-item .nav-icon {
  margin-right: 10px;
}

.menu .submenu .menu-item {
  padding-left: 30px;
}

.menu .submenu .menu-item .nav-icon {
  margin-right: 10px;
}

.text-center {
  text-align: center;
  margin-top: 2rem;
  padding-bottom: 1rem;
}

.text-center img {
  height: 50px;
  width: 50px;
  margin-bottom: 1rem;
}

.text-center .brand-text {
  display: block;
  color: black;
}

@media (max-width: 768px) {
  .sidebar {
      width: 100%;
      float: none;
      padding: 10px;
  }

  .sidebar .menu-item {
      padding: 10px 10px;
  }

  .sidebar .submenu .menu-item {
      padding-left: 20px;
  }

  .sidebar .submenu .menu-item .nav-icon {
      margin-right: 5px;
  }
} */
 .sidebar .brand-link {
  text-align: center !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.sidebar .brand-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;   /* <-- final center fix */
  align-items: center;
}

.sidebar {
  background-color: #343a40;
  color: #c2c7d0;
  padding-top: 20px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Space between items to push the footer to the bottom */
}

.brand-link {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  text-align: center;
  margin-bottom: 1rem;
}

.brand-link img {
  height: 50px;
  width: 50px;
  margin-right: 10px;
  border-radius: 50%;
}

.brand-text {
  font-weight: lighter;
  color: gray;
}

.menu {
  padding-left: 0;
  flex-grow: 1; /* Allow the menu to grow and take available space */
}

.menu .menu-item {
  padding: 10px 20px;
}

.menu .menu-item .nav-icon {
  margin-right: 10px;
}

.menu .submenu .menu-item {
  padding-left: 30px;
}

.menu .submenu .menu-item .nav-icon {
  margin-right: 10px;
}

.text-center {
  text-align: center;
  margin-top: 2rem;
  padding-bottom: 1rem;
}

.text-center img {
  height: 50px;
  width: 50px;
  margin-bottom: 1rem;
}

.text-center .brand-text {
  display: block;
  color: black;
}

@media (max-width: 768px) {
  .sidebar {
      width: 100%;
      float: none;
      padding: 10px;
  }

  .sidebar .menu-item {
      padding: 10px 10px;
  }

  .sidebar .submenu .menu-item {
      padding-left: 20px;
  }

  .sidebar .submenu .menu-item .nav-icon {
      margin-right: 5px;
  }
}

/* For top-level menu */
.active-menu > .pro-menu-item {
  background-color: #1e90ff !important; /* Customize as needed */
  color: #fff;
}

/* For submenu */
.active-submenu > .pro-menu-item {
  background-color: #4682b4 !important;
  color: #fff;
}

/* For leaf menu item */
.active-link {

  color: #000;
  font-weight: bold;
}


`, "",{"version":3,"sources":["webpack://./src/components/sidebar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAoFG;CACF;EACC,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB,IAAI,yBAAyB;EACpD,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAE,yDAAyD;AAC3F;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY,EAAE,oDAAoD;AACpE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE;MACI,WAAW;MACX,WAAW;MACX,aAAa;EACjB;;EAEA;MACI,kBAAkB;EACtB;;EAEA;MACI,kBAAkB;EACtB;;EAEA;MACI,iBAAiB;EACrB;AACF;;AAEA,uBAAuB;AACvB;EACE,oCAAoC,EAAE,wBAAwB;EAC9D,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA,uBAAuB;AACvB;;EAEE,WAAW;EACX,iBAAiB;AACnB","sourcesContent":["/* SidebarContainer.css\n.sidebar {\n  background-color: #343a40;\n  color: #c2c7d0;\n \n  padding-top: 20px;\n}\n\n.brand-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.brand-link img {\n  height: 50px;\n  width: 50px;\n  margin-right: 10px;\n  border-radius: 50%;\n}\n\n.brand-text {\n  font-weight: lighter;\n  color: gray;\n}\n\n.menu {\n  padding-left: 0;\n}\n\n.menu .menu-item {\n  padding: 10px 20px;\n}\n\n.menu .menu-item .nav-icon {\n  margin-right: 10px;\n}\n\n.menu .submenu .menu-item {\n  padding-left: 30px;\n}\n\n.menu .submenu .menu-item .nav-icon {\n  margin-right: 10px;\n}\n\n.text-center {\n  text-align: center;\n  margin-top: 2rem;\n  padding-bottom: 1rem;\n}\n\n.text-center img {\n  height: 50px;\n  width: 50px;\n  margin-bottom: 1rem;\n}\n\n.text-center .brand-text {\n  display: block;\n  color: black;\n}\n\n@media (max-width: 768px) {\n  .sidebar {\n      width: 100%;\n      float: none;\n      padding: 10px;\n  }\n\n  .sidebar .menu-item {\n      padding: 10px 10px;\n  }\n\n  .sidebar .submenu .menu-item {\n      padding-left: 20px;\n  }\n\n  .sidebar .submenu .menu-item .nav-icon {\n      margin-right: 5px;\n  }\n} */\n .sidebar .brand-link {\n  text-align: center !important;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.sidebar .brand-wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;   /* <-- final center fix */\n  align-items: center;\n}\n\n.sidebar {\n  background-color: #343a40;\n  color: #c2c7d0;\n  padding-top: 20px;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between; /* Space between items to push the footer to the bottom */\n}\n\n.brand-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.brand-link img {\n  height: 50px;\n  width: 50px;\n  margin-right: 10px;\n  border-radius: 50%;\n}\n\n.brand-text {\n  font-weight: lighter;\n  color: gray;\n}\n\n.menu {\n  padding-left: 0;\n  flex-grow: 1; /* Allow the menu to grow and take available space */\n}\n\n.menu .menu-item {\n  padding: 10px 20px;\n}\n\n.menu .menu-item .nav-icon {\n  margin-right: 10px;\n}\n\n.menu .submenu .menu-item {\n  padding-left: 30px;\n}\n\n.menu .submenu .menu-item .nav-icon {\n  margin-right: 10px;\n}\n\n.text-center {\n  text-align: center;\n  margin-top: 2rem;\n  padding-bottom: 1rem;\n}\n\n.text-center img {\n  height: 50px;\n  width: 50px;\n  margin-bottom: 1rem;\n}\n\n.text-center .brand-text {\n  display: block;\n  color: black;\n}\n\n@media (max-width: 768px) {\n  .sidebar {\n      width: 100%;\n      float: none;\n      padding: 10px;\n  }\n\n  .sidebar .menu-item {\n      padding: 10px 10px;\n  }\n\n  .sidebar .submenu .menu-item {\n      padding-left: 20px;\n  }\n\n  .sidebar .submenu .menu-item .nav-icon {\n      margin-right: 5px;\n  }\n}\n\n/* For top-level menu */\n.active-menu > .pro-menu-item {\n  background-color: #1e90ff !important; /* Customize as needed */\n  color: #fff;\n}\n\n/* For submenu */\n.active-submenu > .pro-menu-item {\n  background-color: #4682b4 !important;\n  color: #fff;\n}\n\n/* For leaf menu item */\n.active-link {\n\n  color: #000;\n  font-weight: bold;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
